import { BuildInAppToolId, IAppToolConfig } from '../types/appTools';
import { useEvent, useSession } from '@bizzabo/entities';
import { IntegrationPointData, IntegrationPointType } from '../../extensions/types/appExtension';

const useEngagements = (eventUniqueName, sessionId) => {
    const event = useEvent(eventUniqueName);
    const session = useSession(event.data?.id, sessionId);

    let appTools: IAppToolConfig[] = [];

    if (session.data?.engagements) {
        // temporary limitation to one app extension on session level
        /*appTools = session.data.engagements
            .filter(engagement => !engagement.internal)
            .map(engagement => {
                return {
                    id: engagement.extensionId,
                    title: engagement.label,
                    iconUrl: engagement.icon,
                    isVisible: () => true,
                    needSession: true,
                };
            });*/
        const externalEngagements = session.data.engagements.filter(
            engagement => !engagement.internal
        );
        if (externalEngagements?.length) {
            const { extensionId, label } = externalEngagements[0];
            appTools = [
                {
                    id: BuildInAppToolId.SessionExtension,
                    extensionId,
                    type: IntegrationPointType.VENUE_SESSION_SIDE_PANEL,
                    title: IntegrationPointData.VENUE_SESSION_SIDE_PANEL.label,
                    iconUrl: IntegrationPointData.VENUE_SESSION_SIDE_PANEL.icon,
                    isVisible: () => true,
                    needSession: true,
                    category: 'ENGAGEMENT',
                    ...(label && { name: label }),
                },
            ];
        }
    }

    return appTools;
};

export default useEngagements;
